export const sendQuestion = async (
  question: string,
  dialogueId: string | null,
) => {
  const response = await fetch(`${process.env.NEXT_PUBLIC_AI_API_URL}/query`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ question, dialogue_id: dialogueId }),
  });

  const data = await response.json();
  return data;
};
